import React from 'react'
import { number, string, shape, oneOfType, func } from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { Button, Row, Col } from '@gympass/yoga'

import Container from '@components/Container'

import { updateSimulation } from '@client/services/simulate'

import useLoading from '@hooks/useLoading'

import * as Style from './NavigationButtons.style'

export default function NavigationButtons({
  step,
  path,
  actions,
  onNext,
  onPrevious,
  contact,
}) {
  const { setDataLayer } = actions

  const { isLoading, startLoad, finishLoad } = useLoading()

  function handleBackToCommercialInfo() {
    onPrevious()
  }

  async function handleContractOffer() {
    startLoad()

    await updateSimulation({ id: contact.id, funnelStage: 'checkout' })

    setDataLayer(step, path, {
      actorData: {
        email: contact.email,
        role: contact.role,
        department: 'Human Resources',
      },
      companyData: {
        employeesNumber: contact.employeesNumber,
        industry: contact.industry,
        state: contact.state,
      },
      transactionData: {
        offerValue: contact.proposalValue,
      },
    })

    finishLoad()

    if (onNext) {
      onNext()
    }
  }

  return (
    <Style.NavigationButtonsWrapper>
      <Container>
        <Row>
          <Col xxs={12} md={12} xl-start={5} xl={4}>
            <Style.Buttons>
              <Style.ContractButton
                full
                loading={isLoading}
                onClick={handleContractOffer}
                data-testid="next"
              >
                <Style.ButtonText>
                  <FormattedMessage id="smb_acquisition_commercial_offer.page.call_to_action.advance" />
                </Style.ButtonText>
              </Style.ContractButton>

              <Style.RedoSimulation>
                <Button.Outline
                  full
                  onClick={handleBackToCommercialInfo}
                  data-testid="previous"
                >
                  <Style.ButtonText>
                    <FormattedMessage id="smb_acquisition_commercial_offer.page.call_to_action.return" />
                  </Style.ButtonText>
                </Button.Outline>
              </Style.RedoSimulation>
            </Style.Buttons>
          </Col>
        </Row>
      </Container>
    </Style.NavigationButtonsWrapper>
  )
}

NavigationButtons.propTypes = {
  contact: shape({
    employeesNumber: oneOfType([number, string]),
  }).isRequired,
  path: string.isRequired,
  actions: shape({
    setFunnelStage: func,
    setDataLayer: func,
  }).isRequired,
  step: number.isRequired,
  onNext: func,
  onPrevious: func,
}

NavigationButtons.defaultProps = {
  onNext: undefined,
  onPrevious: undefined,
}
